import type { DocMigration } from "../docMigration";

const defaultMaterials = {
  floorInterior: {
    /*...DesignMaterialPath.Color.C, colorId: DMC.SystemColors.Orange*/
    templateId: 2,
    colorId: 28,
  },
  wallInterior: {
    /*...DesignMaterialPath.Color.C, colorId: DMC.SystemColors.Light_Orange*/
    templateId: 2,
    colorId: 23,
  },
  ceiling: {
    /*...DesignMaterialPath.Paint_Satin.C, colorId: DMC.SherwinWilliams.SW_7005_PureWhite*/
    templateId: 17,
    colorId: 239,
  },
  trimInterior: {
    /*...DesignMaterialPath.Paint_SemiGloss.C, colorId: DMC.PaintSpare_Colors.White*/
    templateId: 18,
    colorId: 188,
  },
  doorInterior: {
    /*...DesignMaterialPath.Paint_SemiGloss.C, colorId: DMC.SherwinWilliams.SW_7005_PureWhite*/
    templateId: 18,
    colorId: 239,
  },
  doorFixture: {
    /*...DesignMaterialPath.Metal_Powder.C, colorId: DMC.MetalPowder_Colors.Slate*/
    templateId: 12,
    colorId: 44,
  },
  propDefault: {
    /*...DesignMaterialPath.Color.C, colorId: DMC.SystemColors.White*/
    templateId: 2,
    colorId: 33,
  },
};

function fixInteriorPalette(palette: any) {
  for (const paletteKey of Object.keys(defaultMaterials)) {
    const key0 = paletteKey + "0";
    const key1 = paletteKey + "1";
    const key2 = paletteKey + "2";
    if (!palette.defaultRoomMaterials[key0]) {
      if (palette.defaultRoomMaterials[key1]) {
        palette.defaultRoomMaterials[key0] = { ...palette.defaultRoomMaterials[key1] };
      } else if (palette.defaultRoomMaterials[key2]) {
        palette.defaultRoomMaterials[key0] = { ...palette.defaultRoomMaterials[key2] };
      } else {
        palette.defaultRoomMaterials[key0] = { ...defaultMaterials[paletteKey] };
      }
    }
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_313: DocMigration = {
  maxSchemaVersion: "0.0.313",
  description: "Fix invalid interior palettes",
  apply(json: any) {
    for (const palette of Object.values(json.palettes)) {
      if ((palette as any).type === "INTERIOR_PALETTE") {
        fixInteriorPalette(palette);
      }
    }

    return json;
  },
};

export default migration_0_0_313;
